import styled from "styled-components";
import { Anchor, Flex } from "discover.medical.react-component-library";

export const AZBrowseHeader = styled(Flex)`
  margin-top: 0;
  flex-direction: row;
  justify-content: space-between;

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    flex-direction: column-reverse;
  }
`;

export const AZBrowseSticky = styled.div`
  position: sticky;
  z-index: 9;
  top: 2.5rem;
  padding-bottom: ${({ theme }) => theme.space.xs};
  background-color: ${({ theme }) => theme.colors.white};
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    top: 4rem;
    padding-bottom: ${({ theme }) => theme.space.sm};
  }

  ${({ $isStuck }) =>
    $isStuck &&
    `box-shadow: 0 3px 2px -2px rgba(0, 0, 0, .14),
    0 3px 2px -2px rgba(0, 0, 0, .12), 0 3px 3px -2px rgba(0, 0, 0, .2);
  `};
`;

export const AZLogo = styled.img`
  width: 18rem;

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    width: 12rem;
    margin-top: ${({ theme }) => theme.space.sm};
    margin-bottom: ${({ theme }) => theme.space.sm};
    margin-left: -0.2rem;
  }
`;

export const AnchorWithHighlights = styled(Anchor)`
  mark {
    background: ${({ theme }) => theme.colors.gray100};
    font-weight: ${({ theme }) => theme.font.weight.bold};
    color: inherit;
  }
`;
